export default {
  title: "Nova linha 4990 - Adelmolândia e Paciência para Belo Horizonte",
  resume: "A linha começa a operar hoje (14/07/2025) e atende os passageiros desses bairros.",
  img: "/news/neobus-44089.jpg",
  publishDate: "2025-07-14T00:00:00.000-03:00",
  content: [
    "Uma nova linha foi criada para atender os passageiros que moram nos bairros Paciência e Adelmolândia. A linha 4990 passou a operar na manhã dessa segunda-feira (14/07).",
    "Inicialmente com 4 partidas em dias úteis (de segunda à sexta). A nova linha será uma mão na roda para os passageiros que dependiam de fazer baldeação com as linhas 04 e 03 operadas pela Vinscol, cujo os horários foram abruptamente reduzidos desde o início da pandemia de Covid-19 e nunca mais foi reestabelecido.",
    "<>Veja as <Link to={\"/lines/42\"}>informações atualizadas e em detalhes da linha 4990</Link>.</>"
  ],
};
